const AUTH_URL = 'auth/';

class AuthService {
  async authenticate() {
    await axios.get(AUTH_URL + 'authenticate', {
      headers: {Authorization: accessToken()}
    });
  }

  login(user) {
    return axios
      .post(AUTH_URL + 'signIn', {
        id: user.username,
        password: user.password,
        responseType: "blob"
      })
      .then(this.handleResponse)
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(AUTH_URL + 'signUp', {
      tenant: user.tenant,
      id: user.id,
      name: user.name,
      password: user.password,
      roleCode: user.role
    });
  }

  handleResponse(response) {
    if (response.status === 401) {
      this.logout();
      const error = response.data && response.data.message;
      return Promise.reject(error);
    }
    return Promise.resolve(response);
  }
}

export default new AuthService();
